module.exports = __webpack_public_path__ + "static/media/meme_1.c3c2f342.png";